import React from "react";
import "./Hero.css";
import Header from "../Header/Header";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import Heart from "../../assets/heart.png";
import Calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import { type } from "@testing-library/user-event/dist/type";
import NumberCounter from "number-counter"
const Hero = () => {
  const transition = {type:'spring', duration: 3}
  return (
    <div className="hero">
      <div className="hero-left">
        {/* <Header /> */}
        <Header />
        <div className="best-ad">
          <motion.div
          initial={{ left:'238px' }}
          whileInView={{ left:'8px' }}
          transition={{ ...transition, type:'tween' }}

          ></motion.div>
          <span>THE BEST FITNESS CLUB IN THE TOWN</span>
        </div>
        <div className="hero-text">
          <div>
            <span className="stroke-text-filled">Shape </span>
            <span> your</span>
          </div>
          <div>
            <span>Ideal body</span>
          </div>
          <div className="span">
            In here we will help you to shape and build your ideal body and live
            up your life to fullest
          </div>
        </div>
        {/* this  figures */}
        <div className="fugures">
          <div>
            <span>
              <NumberCounter end={140} start={100} delay="4" preFix="+"/>
            </span>
            <span>expert coaches</span>
          </div>
          <div>
            <span>
               <NumberCounter end={948} start={900} delay="4" preFix="+"/>
            </span>
            <span>Members joined</span>
          </div>
          <div>
            <span>
               <NumberCounter end={50} start={20} delay="4" preFix="+"/>
            </span>
            <span>fitness programs</span>
          </div>
        </div>
        {/* hero button */}
        <div className="hero-button">
          <buttons className="btn">Get started</buttons>
          <buttons className="btn">Learn More.</buttons>
        </div>
      </div>
      <div className="hero-right">
        <button className="btn"> Join Now</button>

        <motion.div className="heart-rate"
             initial= {{ right:"-1rem" }}
          whileInView={{ right:'4rem' }}
          transition={transition}
        
        
        >
     
          <img src={Heart} alt="" />
          <span>heart rate</span>
          <span>116 bpm</span>
        </motion.div>
        <img src={hero_image} alt="" className="hero-image" />
        <motion.img
         initial= {{ right:"11rem" }}
          whileInView={{ right:'20rem' }}
          transition={transition}
        src={hero_image_back} alt="" className="hero-image-back" />
        <motion.div className="calories"
        
           initial= {{ right:"37rem" }}
          whileInView={{ right:'28rem' }}
          transition={transition}
        
        >
          
          <img src={Calories} alt="" />
          <div>
            <span>Calories burned</span>
          <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
